import { ErrorHandler, Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

@Injectable()
export class ToastErrorHandler extends ErrorHandler {
    constructor() {
        // The true paramter tells Angular to rethrow exceptions, so operations like 'bootstrap' will result in an error
        // when an error happens. If we do not rethrow, bootstrap will always succeed.
        super();
    }

    handleError(error) {
        console.log(error);
        let message: string = error.rejection ? error.rejection.message : error.message;

        if (error.rejection && error.rejection.entityErrors) {
            message = `${message}; Entity Errors:`;
            error.rejection.entityErrors.forEach((entityError) => {
                message = `${message} ${entityError.errorMessage};`;
            });
        }

        if (message?.indexOf(`<title>`) > 0) {
            message = 'Network error<br>' + message.substring(message.indexOf(`<title>`), message.indexOf(`</title>`));
        }

        if (message?.indexOf('ExpressionChangedAfterItHasBeenCheckedError') === -1) {
            notify({
                position: { my: 'center top', at: 'center top', offset: '0 20', of: 'body' },
                message,
                closeOnClick: true,
                displayTime: 6000,
                width: '400px',
                type: 'error',
            });
        }
    }
}
